<div class="ce-row">
  <div class="ce-col-lg-3 ce-col-md-12 ce-col-sm-12 ce-col-12">
    <div class="grid">
      <div class="d-flex flex-column">
        <h3 class="h4-reg primary-60"><span class="pulse-dot"></span> Real Time</h3>
        <div class="h2-subheaders primary-100">{{ (activeUsers$ | async) ?? 0 }} online</div>
      </div>
    </div>
  </div>

  <div class="ce-col-lg-3 ce-col-md-12 ce-col-sm-12 ce-col-12">
    <app-analytics-trend-widget
      title="Visitors"
      metricsKey="unique_users"
      [context]="context"
      [analytics]="visitorAnalytics$ | async"
      [errorState]="(visitorAnalyticsErrorMessage$ | async) || false">
    </app-analytics-trend-widget>
  </div>

  <div class="ce-col-lg-3 ce-col-md-12 ce-col-sm-12 ce-col-12">
    <app-analytics-trend-widget
      title="Page views"
      metricsKey="total_views"
      [context]="context"
      [analytics]="viewAnalytics$ | async"
      [errorState]="(viewAnalyticsErrorMessage$ | async) || false">
    </app-analytics-trend-widget>
  </div>

  <div class="ce-col-lg-3 ce-col-md-12 ce-col-sm-12 ce-col-12">
    <app-analytics-trend-widget
      title="Events"
      metricsKey="total_events"
      [context]="context"
      [analytics]="eventAnalytics$ | async"
      [errorState]="(eventAnalyticsErrorMessage$ | async) || false">
    </app-analytics-trend-widget>
  </div>
</div>

<div class="ce-row">
  <div class="ce-col-lg-6 ce-col-md-12 ce-col-sm-12 ce-col-12 flex-1 h-full">
    <div class="grid">
      <app-traffic-matrix
        class="w-100"
        [headingTitle]="'Traffic'"
        [subtitle]="'Understand which days and hours of the day are most popular'"
        [context]="context"
        [data]="(trafficMatrixData$ | async) ?? []">
      </app-traffic-matrix>
    </div>
  </div>

  <div class="ce-col-lg-6 ce-col-md-12 ce-col-sm-12 ce-col-12 flex-1 h-full">
    <div class="grid">
      <app-analytics-widget
        class="w-100"
        title="Visitors"
        subtitle="Number of visitors in the selected period"
        metricsKey="unique_users"
        [height]="260"
        [compare]="comparePeriod"
        [context]="context"
        [analytics]="visitorAnalytics$ | async"></app-analytics-widget>
    </div>
  </div>
</div>

<div class="ce-row">
  <div class="ce-col-lg-6 ce-col-md-12 ce-col-sm-12 ce-col-12 h-full">
    <div class="grid">
      <app-custom-bar-chart-container
        class="chart-container w-100"
        [height]="'auto'"
        [width]="'auto'"
        [legend]="false"
        [chartType]="'bar'"
        [DataLabel]="'Source'"
        [headingTitle]="'Visitors by source'"
        [subtitle]="'Understand which sources and campaigns are driving traffic'"
        [multipleTitles]="visitorMetricTitles"
        [statsMap]="(visitorsBySourceStats$ | async) ?? {}"
        [tabs]="(visitorsBySourceTabs$ | async) ?? []"
        [defaultActiveTab]="(visitorsBySourceActiveTab$ | async) ?? ''"
        [showPagination]="true"
        [paginationData]="$any(visitorsBySourcePagination$ | async) || defaultPagination"
        (tabChange)="onVisitorsTabChange($event)"
        (pageChange)="onVisitorsPageChange($event)"
        [badgeType]="'white'"
        [errorState]="(visitorsBySourceError$ | async) ?? false">
      </app-custom-bar-chart-container>
    </div>
  </div>

  <div class="ce-col-lg-6 ce-col-md-12 ce-col-sm-12 ce-col-12">
    <div class="grid">
      <app-high-chart-container
        class="w-100"
        headingTitle="Popular pages"
        subtitle="Pages with the highest number of visits"
        [chartOptions]="(pageStatsChartOptions$ | async) ?? {}"
        [emptyStateMessage]="'No page views recorded for the selected period'"
        [errorState]="(pageStatsError$ | async) ?? false">
      </app-high-chart-container>
    </div>
  </div>
</div>

<div class="ce-row">
  <div class="ce-col-lg-6 ce-col-md-12 ce-col-sm-12 ce-col-12">
    <div class="grid">
      <app-high-chart-container
        class="w-100"
        headingTitle="Visitors by device type"
        subtitle="Breakdown of visitors by device type"
        [chartOptions]="(visitorsByDeviceChartOptions$ | async) ?? {}"
        [chartType]="'pie'"
        [emptyStateMessage]="'No device data available for the selected period'"
        [errorState]="(visitorsByDeviceError$ | async) ?? false">
      </app-high-chart-container>
    </div>
  </div>

  <div class="ce-col-lg-6 ce-col-md-12 ce-col-sm-12 ce-col-12">
    <div class="grid">
      <app-high-chart-container
        class="w-100"
        headingTitle="Popular events"
        subtitle="Most popular events in the selected period"
        [chartOptions]="(serverEventsChartOptions$ | async) ?? {}"
        [chartType]="'pie'"
        [emptyStateMessage]="'No server events recorded for the selected period'"
        [errorState]="(serverEventsError$ | async) ?? false">
      </app-high-chart-container>
    </div>
  </div>
</div>
